<template lang="html">
  <div class="step-wrapper">
    <div class="step-index">
      {{ $t(data.stepIndex) }}:
      <span class="step-title">{{ $t(data.stepTitle) }}</span>
    </div>
    <div
      :class="{ hidden: data.hidden }"
      v-html="$t(data.stepDescription)"
      class="step-description"
    ></div>
  </div>
</template>

<script>
export default {
  name: "manualStep",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.step-index {
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 21px;
  line-height: 30px;
  color: rgba(79, 79, 79, 0.7);
  margin-bottom: 20px;
  text-align: left;

  .step-title {
    font-weight: 800;
    letter-spacing: 0.02em;
    color: #8e3e4c;
    text-align: left;
  }
}
.step-description {
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04em;
  color: rgba(79, 79, 79, 0.96);
  text-align: left;
}
.step-description.hidden {
  max-height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
